import api, { apiSetup } from '../api';

apiSetup();

export class TerritoriesService {
  BASE_URL = '/territories/all';

  get() {
    return api.get(this.BASE_URL);
  }
}
